module.exports = __webpack_public_path__ + "static/img/zph-logo.cde312f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fair/zph-logo.png
// module id = xiHc
// module chunks = 90